import React from 'react';
import {
  Box,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton as MuiIconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';

export default function Dialog({
  open,
  onClose,
  title,
  subtitle,
  children,
  actions,
  maxWidth = 'sm',
  fullWidth = true,
  fullScreen = false,
  showCloseButton = true,
  ariaLabelledby,
  contentSx = {},
}) {
  const { semantic, typography } = useFeatureTheme();
  const titleId = ariaLabelledby || 'ui-dialog-title';

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
    >
      {(title || showCloseButton) && (
        <DialogTitle
          id={titleId}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            fontSize: typography.fontSizeLg,
            fontWeight: typography.fontWeightSemibold,
            color: semantic.text.primary,
            pr: showCloseButton ? 1 : 3,
            pb: subtitle ? 1 : undefined,
          }}
        >
          <Box sx={{ minWidth: 0, pr: 1 }}>
            <Box component="span" sx={{ display: 'block' }}>
              {title}
            </Box>
            {subtitle ? (
              <Typography
                component="p"
                sx={{
                  mt: 0.75,
                  mb: 0,
                  fontSize: typography.fontSizeSm,
                  fontWeight: typography.fontWeightRegular,
                  lineHeight: 1.5,
                  color: semantic.text.secondary,
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {showCloseButton && (
            <MuiIconButton aria-label="Close dialog" onClick={onClose} size="small" sx={{ mt: -0.25 }}>
              <CloseIcon fontSize="small" />
            </MuiIconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent dividers sx={{ color: semantic.text.primary, ...contentSx }}>
        {children}
      </DialogContent>

      {actions ? <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>{actions}</DialogActions> : null}
    </MuiDialog>
  );
}
